/**
 * 接口地址
 */
export const ApiPath = {
  Service: {
    MerchantOpenPlatform: '/gateway/merchant-service/api/open-platform/',
  },
  Path: {
    PolicyList: 'list-merchant-policies',
    shoplazzaBPPolicyList: 'list-merchant-bp-policies',
    PolicyDetail: 'get-policy-detail',
  },
};

/**
 * 返回状态码
 */
export const RespCode = {
  Success: 0,
};

/**
 * 错误码
 */
export const ErrorCode = {
  /** 登录态过期 */
  Expired: 401,
  /** 接口错误 */
  Wrong: -9999,
};
